var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tabs-footer"}},[(_vm.data.type ==='cutaway' && !_vm.data.activeHotspot)?_c('CutawayFloorsFooter',{attrs:{"data":_vm.data}}):_vm._e(),_vm._v(" "),( _vm.data.type ==='configurable-tour')?_c('RoomItemsFooter',{attrs:{"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67090e1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/alternative/layout/FooterLayout.vue
// module id = null
// module chunks = 